import { useSearchParams } from 'react-router-dom'
import { detectLang, t } from '../lib/i18n'
import { RequestForm } from '../components/request-form'

export function RequestPage() {
  const [params] = useSearchParams()
  const lang = detectLang(params)

  return (
    <section className="mx-auto max-w-prose">
      <h1 className="text-3xl font-semibold tracking-tight text-text">
        {t(lang, 'request.title')}
      </h1>
      <p className="mt-3 text-text-muted">{t(lang, 'request.subtitle')}</p>
      <div className="mt-8">
        <RequestForm lang={lang} />
      </div>
    </section>
  )
}
